import { useContext, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { logger } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import { EventReportingManagerContext } from '../../../../../../components/EventReportingManager';
import { type CurrencyObject, getDefaultCurrencyObject } from './utils';

export const useCurrencyObject = (currencyObject: CurrencyObject, componentName: string) => {
    const { url } = getContext();
    const {
        context: {
            page: { name: pageName },
        },
        enabled: reportingEnabled,
    } = useContext(EventReportingManagerContext);

    useEffect(() => {
        if (isEmpty(currencyObject) && reportingEnabled) {
            logger.warn(`Missing currencyObject for ${componentName}`, { url, pageName });
        }
    }, [componentName, currencyObject, pageName, reportingEnabled, url]);

    return !isEmpty(currencyObject) ? currencyObject : getDefaultCurrencyObject();
};
